import type { Distance, Point } from "@pdfking/math"
import { Abs, Subtract } from "@pdfking/math"
import { MM } from "@pdfking/quantity"

// Closer than this, two points are one.
const TOLERANCE = MM(0.001)

/** Whether two points of a die are one. */
export const FolderSame = (a: Point<Distance>, b: Point<Distance>): boolean =>
  Abs(Subtract(a.x, b.x)) < TOLERANCE && Abs(Subtract(a.y, b.y)) < TOLERANCE
